import { Component } from '@angular/core';
import { FUNDAMENT_PREFIX } from '../fundament/fundament-prefix';

@Component({
  selector: 'app-loading-app',
  templateUrl: './loading-app.component.html',
  styleUrls: ['./loading-app.component.scss'],
})
export class LoadingAppComponent {
  prefix = FUNDAMENT_PREFIX;

  get isBrowserUnsupported() {
    return (
      navigator.userAgent.indexOf('MSIE') !== -1
      || navigator.appVersion.indexOf('Trident/') > -1
    );
  }
}
